module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    class: (_vm.className ? _vm.className + '-wrapper ' : '') + 'autocomplete-wrapper'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    class: (_vm.className ? _vm.className + '-input ' : '') + 'autocomplete-input form-control',
    attrs: {
      "type": "text",
      "id": _vm.id,
      "placeholder": _vm.placeholder,
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.type)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.type = $event.target.value
      }, function($event) {
        return _vm.input(_vm.type)
      }],
      "dblclick": _vm.showAll,
      "blur": _vm.hideAll,
      "keydown": _vm.keydown,
      "focus": _vm.focus
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showList),
      expression: "showList"
    }],
    class: (_vm.className ? _vm.className + '-list ' : '') + 'autocomplete transition autocomplete-list'
  }, [_c('ul', _vm._l((_vm.json), function(data, i) {
    return _c('li', {
      class: _vm.activeClass(i),
      attrs: {
        "transition": "showAll"
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.selectList(data)
        },
        "mousemove": function($event) {
          return _vm.mousemove(i)
        }
      }
    }, [_c('b', [_vm._v(_vm._s(data[_vm.anchor]))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(data[_vm.label]))])])])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea6fc392","hasScoped":true}!./src/components/autocomplete/vue-autocomplete.html
// module id = 557
// module chunks = 1